import { getUserLang, isEuEnv } from '@mb/lib/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config';
import { Brand } from '../../redux/sliceCreators/brandsSlice';
import { client } from '../http';

const userLang = getUserLang();

interface CustomError {
  message: string;
}
interface FetchBrandsResponse {
  items: Brand[];
  search_criteria: {
    filter_groups: unknown[];
  };
  total_count: number;
}

export const getBrandsThunk = createAsyncThunk<
  Brand[],
  void,
  { rejectValue: CustomError }
>('brands/get', async (_, thunkApi) => {
  try {
    const langPrefix = isEuEnv ? `/${userLang}` : '';
    const response = await client.get<FetchBrandsResponse>(
      langPrefix +
        config.endpoints.fetchBrands +
        '?fields[1]=status&fields[2]=menu_visibility',
    );
    return response.data.items;
  } catch (e: any) {
    const message = e.response?.data?.message ?? 'Failed to fetch brands data.';
    return thunkApi.rejectWithValue({ message });
  }
});
